/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyXrp = createReactComponent("outline", "currency-xrp", "IconCurrencyXrp", [["path", { "d": "M5 5l3.585 3.585a4.83 4.83 0 0 0 6.83 0l3.585 -3.585", "key": "svg-0" }], ["path", { "d": "M5 19l3.585 -3.585a4.83 4.83 0 0 1 6.83 0l3.585 3.584", "key": "svg-1" }]]);

export { IconCurrencyXrp as default };
//# sourceMappingURL=IconCurrencyXrp.mjs.map
